import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Typography, styled } from "@mui/material";
import { ReactNode } from "react";

export const MenuSectionBox = styled(Box)(
  ({
    theme: {
      spacing,
      palette: { grey },
    },
  }) => ({
    padding: spacing(1, 0),
    borderBottom: `thin solid ${grey[300]}`,
  })
);

export const MenuSectionHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  pb: 2,
});

interface MenuSectionProps {
  title: string;
  expanded: boolean;
  onClick: () => void;
  children: ReactNode;
}

export const MenuSection = ({ title, expanded, onClick, children }: MenuSectionProps) => {
  const icon = expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />;
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <MenuSectionBox>
      <MenuSectionHeader
        onClick={onClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
        aria-expanded={expanded}
        aria-label={title}
      >
        <Typography>{title}</Typography>
        {icon}
      </MenuSectionHeader>
      {expanded && children}
    </MenuSectionBox>
  );
};
